(function () {
  "use strict";

  angular.module("sempraWebapp").service("sortArrayService", sortArrayService);

  /** @ngInject */
  function sortArrayService() {
    this.sortByTime = function (array) {
      return array.sort(compareByTime);
    };

    function compareByTime(a, b) {
      if (a.timestamp < b.timestamp) {
        return -1;
      }
      if (a.timestamp > b.timestamp) {
        return 1;
      }
      return 0;
    }

    this.sortByGroupValue = function (array) {
      return array.sort(compareByGroupValue);
    };

    function compareByGroupValue(a, b) {
      if (a.groupValue < b.groupValue) {
        return -1;
      }
      if (a.groupValue > b.groupValue) {
        return 1;
      }
      return 0;
    }

    this.sortArrayById = function (array) {
      return array.sort(function (a, b) {
        return parseFloat(a.id) - parseFloat(b.id);
      });
    };

  }
})();
